import { render, staticRenderFns } from "./magazinesListComponent.vue?vue&type=template&id=69dd25b2&"
import script from "./magazinesListComponent.vue?vue&type=script&lang=ts&"
export * from "./magazinesListComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports